// extracted by mini-css-extract-plugin
module.exports = {"footer":"AdvertisementModal_footer__2Q9zw","header":"AdvertisementModal_header__19C5S","check":"AdvertisementModal_check__3h-5C","copyright":"AdvertisementModal_copyright__1DW_L"};